import React from 'react'
import CloseLink from '../CloseLink'

const About = () => {
  return (
    <>
      <div className='z-40 absolute top-20 md:top-0 right-0 bottom-0 glass w-full md:w-3/5'>
        <CloseLink />
        <div className='h-full w-full overflow-y-auto hide-scrollbar'>
          <div className='p-4 md:p-16 text-white'>
            <h1 className='text-sm text-black hidden md:block uppercase font-bold text-white'>About</h1>
            <h2 className='hidden md:block text-6xl text-black font-bold mb-6 text-white'>NIIVA</h2>
            
            <p className='text-2xl tracking-wider leading-10 glass-above mb-6 text-justify text-white bg-black py-4 px-6'>
              NIIVA is a Bulgarian-born, England-raised, now Canadian-based pop artist who has cemented her as a rising force in modern pop. With accolades like iHeart Radio's Future Star, KiSS RADiO's One To Watch, and Amazon Music Canada's Breakthrough Artist, she first captured national attention with her Billboard-charting single Friends, which hit #13 on CHR.
            </p>

            <p className='text-2xl tracking-wider leading-10 glass-above mb-6 text-justify text-white bg-black py-4 px-6'>
              Now, NIIVA unveils Fussier - the extended edition of her acclaimed Fussy EP - led by the introspective single Custom Fit. Where Fussy celebrated womanhood in all its beautiful contradictions, Fussier dives deeper into self-definition, knowing who you are and building a life that fits you, free from anyone else’s checklist. Custom Fit is an ode to freedom: the sound of letting go and slipping into something that finally feels like home.
            </p>

            <p className='text-2xl tracking-wider leading-10 glass-above mb-6 text-justify text-white bg-black py-4 px-6'>
              Orchestral strings, gritty basslines, and angelic harmonies capture the layered complexity of femininity with emotional punch. The single Fussy, featuring Canadian drag superstar Priyanka, turns high standards into high art, while earlier singles like Girls offer a playful love letter to sisterhood.
            </p>

            <p className='text-2xl tracking-wider leading-10 glass-above mb-6 text-justify text-white bg-black py-4 px-6'>
              As a songwriter, NIIVA co-wrote aespa's record-breaking debut Black Mamba and has penned for Oh My Girl, Xiumin, and more.
            </p>

            <p className='text-2xl tracking-wider leading-10 glass-above mb-6 text-justify text-white bg-black py-4 px-6'>
              With nearly a billion streams and an unmistakable blend of cinematic pop, wit, and vulnerability, NIIVA invites listeners to embrace their full selves - no edits, no apologies.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default About